import { TABLE_CELL } from '../../../types/BlockTypes';
import withoutSelectionSnapshots from '../../utils/withoutSelectionSnapshots';
import resetBlocks from '../../utils/resetBlocks';
export default function onBackspace(event, editor, next) {
  var selection = editor.value.selection;

  if (editor.isSelectionAroundTable()) {
    event.preventDefault();
    editor.snapshotSelection();
    return withoutSelectionSnapshots(editor, function () {
      return editor.withoutNormalizing(function () {
        var cells = editor.value.blocks.filter(function (block) {
          return block.type === TABLE_CELL;
        });
        resetBlocks(editor, cells);
        return next();
      });
    });
  }

  if (editor.value.selection.isExpanded && editor.value.anchorBlock !== editor.value.focusBlock) {
    event.preventDefault();
    editor.emptyTableCellsAtSelection();

    if (editor.value.selection.isCollapsed) {
      return false;
    }

    return next();
  }

  if (selection.isExpanded || !editor.query('isAtStartOfBlock')) {
    return next();
  }

  event.preventDefault();
  return editor.moveToAnchor().moveToEndOfPreviousBlock();
}